<div class="activity-task-pane" cdkDropListGroup>
	<div class="tasks-container">
		<div class="task-pane-header">
			<h4>{{ 'activity-task-pane-title' | translate }}</h4>
		</div>
		<div
			cdkDropList
			id="task-list"
			class="task-list-container"
			[class.edit-mode]="isEditMode"
			role="list"
			(cdkDropListDropped)="drop($event)"
			[cdkDropListDisabled]="!isEditMode">
			@for (task of (isEditMode ? (visibleModifiedTasks$ | async) : (visibleFilteredTasks$ | async)); track task.id; let i = $index) {
				<div class="task-item-wrapper">
					<div
						#listItem
						cdkDrag
						tabindex="0"
						class="task-item"
						[class.active]="selectedTaskType === task.type"
						[class.completed]="task.completed"
						role="listitem"
						[attr.data-cy]="'activity-tasks-' + task.type"
						[attr.data-tour]="shouldShowLearnerTourPulse(task) ? 'task-item-incomplete' : null"
						[attr.aria-label]="task.completed
							? ('activity-task-list_complete-task-aria-label' | translate:{name: task.name})
							: ('activity-task-list_incomplete-task-aria-label' | translate:{name: task.name})"
						[cdkDragDisabled]="!isEditMode"
						[cdkDragData]="task"
						(keyup.enter)="onTaskClick(task)"
						(keyup.space)="onTaskClick(task)"
						(click)="onTaskClick(task)">

						@if (isEditMode) {
							<div
								class="drag-handle"
								cdkDragHandle
								tabindex="0"
								accessibleDropList
								[accessibleDropListDisabled]="!isEditMode"
								[count]="(visibleModifiedTasks$ | async)?.length || 0"
								[attr.aria-label]="'aria-ng-sortable_inform-reorderable-name' | translate: {name: task.name}"
								[currentIndex]="i"
								[itemId]="task.id"
								[name]="task.name"
								(activeItemChange)="onActiveItemChange($event)"
								(cancelReorder)="onCancelReorder($event)"
								(finalizePosition)="onFinalizePosition()">
								<span class="ficon-app-drag-handle">
									<i class="ficon-app-gripper-dots-vertical"></i>
								</span>
							</div>
						}

						@if (!isEditMode) {
							<div class="task-status">
								<div
									class="status-circle"
									[class.completed]="task.completed"
									[class.active]="selectedTaskType === task.type">
									@if (task.completed) {
										<span class="ficon-app-checkmark"></span>
									}
								</div>
							</div>
						}

						<div class="task-name">{{ task.name }}</div>
					</div>

					@if (isEditMode && task.type !== 'present') {
						<button
							class="btn-none remove-button"
							type="button"
							(click)="onTaskRemove(task); $event.stopPropagation()"
							[attr.aria-label]="'common_remove' | translate">
							<span class="ficon-app-x"></span>
						</button>
					}
				</div>
			}
		</div>
	</div>

	@if (isEditMode && (recommendedTasks$ | async)?.length > 0) {
		<div class="recommended-tasks-container">
			<div class="task-pane-header">
				<h4>{{ 'activity-task-list_recommended-tasks' | translate }}</h4>
				<mat-icon
					class="ficon-app-help-circle-outline"
					[matTooltip]="'activity-task-list_recommended-tasks-tooltip' | translate"
				></mat-icon>
			</div>
			<div
				cdkDropList
				id="recommended-list"
				class="recommended-task-list"
				role="list"
				(cdkDropListDropped)="onRecommendedDrop($event)"
				[cdkDropListSortingDisabled]="true">
				@for (task of recommendedTasks$ | async; track task.type; let i = $index) {
					<div class="task-item-wrapper">
						<div
							#recommendedListItem
							cdkDrag
							tabindex="0"
							class="task-item"
							role="listitem"
							[attr.aria-label]="'aria-ng-sortable_inform-reorderable-name' | translate: {name: task.name}"
							accessibleDropList
							[count]="(recommendedTasks$ | async)?.length"
							[currentIndex]="i"
							[cdkDragData]="task"
							[itemId]="task.id"
							[name]="task.name">

							<div class="task-name">{{ task.name }}</div>
						</div>

						<button
							class="btn tertiary-btn add-button"
							type="button"
							(click)="onAddRecommendedTask(task)"
							[attr.aria-label]="'activity-task-list_add-task' | translate: {name: task.name}">
							<span class="ficon-add"></span>
							{{ 'common_add' | translate }}
						</button>
					</div>
				}
			</div>
		</div>
	}
</div>
